export const Logo = () => (
  <div style={{ width: '150px', height: '28px', color: 'white' }}>
    TheaterCrunch
  </div>
)
